(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue', {
            parent: 'entity',
            url: '/queue?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue/queues.html',
                    controller: 'QueueController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-detail', {
            parent: 'entity',
            url: '/queue/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue/queue-detail.html',
                    controller: 'QueueDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Queue', function($stateParams, Queue) {
                    return Queue.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-detail.edit', {
            parent: 'queue-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-dialog.html',
                    controller: 'QueueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.new', {
            parent: 'queue',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-dialog.html',
                    controller: 'QueueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dtIns: null,
                                type: null,
                                status: null,
                                dtUpdate: null,
                                name: null,
                                dtFirstExecution: null,
                                userInsert: null,
                                userFirstExec: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('queue');
                });
            }]
        })
        .state('queue.edit', {
            parent: 'queue',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-dialog.html',
                    controller: 'QueueDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.delete', {
            parent: 'queue',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-delete-dialog.html',
                    controller: 'QueueDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.import', {
            parent: 'queue',
            url:  '/{id}/import',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-import.html',
                    controller: 'QueueImportController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue.process', {
            parent: 'queue',
            url:  '/{id}/process',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue/queue-process.html',
                    controller: 'QueueProcessController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue', function(Queue) {
                            return Queue.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue', null, { reload: 'queue' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
